import Layout from '@/layout'

export default [
	{
		order: 15,
		path: '/voltage-regulator-manage',
		component: Layout,
		meta: {
			title: '调压器管理',
			subtitle: '调压器',
			icon: 'icon-shebei1',
		},
		redirect: '/voltage-regulator-manage/voltage-account',
		children: [
			{
				path: '/voltage-regulator-manage/voltage-account',
				name: 'voltageAccount',
				meta: {
					title: '调压器台账',
					keepAlive: true,
					hidden: false,
					permissions: ['monitor:nqi:pressure-regulator:ledger:query'],
				},
				component: () => import('@/pages/voltage-regulator-manage/voltage-account/index.vue'),
			},
			{
				path: '/voltage-regulator-manage/voltage-account/create/:id?',
				name: 'voltageAccountCreate',
				meta: {
					title: '新增调压器',
					keepAlive: false,
					hidden: true,
					noTag: true,
					customCrumb: [
						{ customCrumbTitle: '调压器管理', path: '/voltage-regulator-manage' },
						{ customCrumbTitle: '调压器台账', path: '/voltage-regulator-manage/voltage-account' },
						{ customCrumbTitle: '编辑调压器' },
					],
					permissions: [
						'monitor:nqi:pressure-regulator:ledger:add',
						'monitor:nqi:pressure-regulator:ledger:edit',
					],
				},
				component: () => import('@/pages/voltage-regulator-manage/voltage-account/Create.vue'),
			},
			{
				path: '/voltage-regulator-manage/voltage-account/relation-config',
				name: 'voltageAccountRelationConfig',
				meta: {
					title: '关联设备配置',
					keepAlive: false,
					hidden: true,
					noTag: true,
					permissions: [
						'monitor:nqi:pressure-regulator:ledger:bind-collector',
						'monitor:nqi:pressure-regulator:ledger:device-config',
					],
				},
				component: () => import('@/pages/voltage-regulator-manage/voltage-account/RelationConfig.vue'),
			},
			{
				path: '/voltage-regulator-manage/voltage-monitor',
				name: 'voltageMonitor',
				meta: {
					title: '调压器监控',
					keepAlive: true,
					hidden: false,
					permissions: ['monitor:nqi:pressure-regulator:monitor'],
				},
				component: () => import('@/pages/voltage-regulator-manage/voltage-monitor/index.vue'),
			},
			{
				path: '/voltage-regulator-manage/voltage-account/details',
				name: 'voltageAccountDetails',
				meta: {
					title: '调压器详情',
					keepAlive: false,
					hidden: true,
				},
				component: () => import('@/pages/voltage-regulator-manage/voltage-account/details'),
			},
			{
				path: '/voltage-regulator-manage/operation-profile',
				name: 'operationProfile',
				meta: {
					title: '运行特征画像',
					keepAlive: true,
					hidden: false,
					permissions: ['monitor:nqi:pressure-regulator:portrait:detail'],
				},
				component: () => import('@/pages/voltage-regulator-manage/operation-profile/index.vue'),
			},
		],
	},
]
